<template>
    <div>
      <c-search-box @enter="getList">
        <template slot="search">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <!-- 사업장 -->
            <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-datepicker
              label="대상년도"
              type="year"
              default="today"
              v-model="searchParam.participantYear"
            />
          </div>
          <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-select
              :comboItems="statusItems"
              type="search"
              itemText="codeName"
              itemValue="code"
              name="requestFlag"
              label="요청상태"
              v-model="searchParam.requestFlag"
            ></c-select>
          </div> -->
        </template>
      </c-search-box>
      <c-table
        ref="table"
        title="회차별 참여자 관리 목록"
        tableId="table"
        :columns="grid.columns"
        :data="grid.data"
        :columnSetting="false"
        :isFullScreen="false"
        :usePaging="false"
        :expandAll="true"
        @linkClick="linkClick"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="linkClick" />
            <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </template>
      </c-table>
      <c-dialog :param="popupOptions"></c-dialog>
    </div>
  </template>
  
  <script>
  import selectConfig from '@/js/selectConfig';
  export default {
    name: 'participantStatus',
    data() {
      return {
        grid: {
          columns: [
            {
              name: 'plantName',
              field: 'plantName',
              label: 'LBLPLANT',
              align: 'center',
              style: 'width:100px',
              sortable: true,
            },
            {
              name: 'participantYear',
              field: 'participantYear',
              label: '대상년도',
              style: 'width:100px',
              align: 'center',
              sortable: true,
            },
            {
              name: 'participantRound',
              field: 'participantRound',
              label: '회차',
              style: 'width:80px',
              align: 'center',
              sortable: true,
            },
            {
              name: 'participantTitle',
              field: 'participantTitle',
              label: '제목',
              style: 'width:400px',
              align: 'left',
              sortable: true,
              type: 'link'
            },
           // {
            // name: 'requestFlagName',
            // field: 'requestFlagName',
            // label: '요청상태',
            // style: 'width:100px',
            // align: 'center',
            // sortable: true,
           // },
          ],
          data: [],
        },
        searchParam: {
          plantCd: null,
          participantYear: '',
          requestFlag: null,
        },
        editable: true,
        listUrl: '',
        popupOptions: {
          target: null,
          title: '',
          visible: false,
          isFull: false,
          top: '',
          param: {},
          closeCallback: null,
        },
        statusItems: [
          { code: 'N', codeName: '요청전' },
          { code: 'Y', codeName: '요청완료' },
        ],
        period: [],
      };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
      Object.assign(this.$data, this.$options.data());
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
    },
    methods: {
      init() {
        this.editable = this.$route.meta.editable;
        this.listUrl = selectConfig.hea.etr.participant.list.url;
        this.getList();
      },
      getList() {
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = this.searchParam;
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      },
      linkClick(result) {
        this.popupOptions.target = () => import(`${"./participantStatusDetail.vue"}`);
        this.popupOptions.title = '참여자 현황 상세';
        this.popupOptions.param = {
          heaEtrParticipantStatusId: result ? result.heaEtrParticipantStatusId : '',
        };
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closePopup;
      },
      closePopup() {
        this.popupOptions.target = null;
        this.popupOptions.visible = false;
        this.getList();
      },
    }
  };
  </script>
  